import React, { Fragment, useContext } from "react";
import clsx from "clsx";
import { Theme, makeStyles } from "@material-ui/core/styles";
import { Typography, Button } from "@material-ui/core";
import { FaRulerCombined, FaRulerHorizontal } from "react-icons/fa";
import { DesignContext } from "../../context/design";

const useStyles = makeStyles((theme: Theme) => ({
  default: { color: theme.palette.secondary.main },
  active: { color: theme.palette.primary.main },
  spaceInGroup: {
    marginLeft: theme.spacing(0.5),
    marginTop: theme.spacing(1),
  },
  flexMiddle: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  btnSelect: {
    boxShadow: "unset",
    padding: theme.spacing(0.3),
    width: theme.spacing(4),
    height: theme.spacing(4),
    fontFamily: ["Montserrat-Bold", "Kanit-Bold"].join(","),
    minWidth: "unset",
  },
  faIcon: { width: theme.spacing(3), height: theme.spacing(2.5) },
}));

const Measure = () => {
  const classes = useStyles();

  const { event, setevent } = useContext(DesignContext);
  const { type } = event;

  const _activeMeasure = (measureType: "measure-area" | "measure-length") => (
    e: any
  ) => {
    setevent({
      ...event,
      type: type === measureType ? undefined : measureType,
      feature: undefined,
    });
  };

  return (
    <Fragment>
      <Typography variant="subtitle2" className={clsx(classes.flexMiddle)}>
        Measure:
      </Typography>
      <Button
        variant="outlined"
        size="small"
        color={type !== "measure-area" ? "default" : "primary"}
        className={clsx(classes.btnSelect, classes.spaceInGroup)}
        onClick={_activeMeasure("measure-area")}
      >
        <FaRulerCombined
          className={clsx(
            type !== "measure-area" ? classes.default : classes.active,
            classes.faIcon
          )}
        />
      </Button>
      <Button
        variant="outlined"
        size="small"
        color={type !== "measure-length" ? "default" : "primary"}
        className={clsx(classes.btnSelect, classes.spaceInGroup)}
        onClick={_activeMeasure("measure-length")}
      >
        <FaRulerHorizontal
          className={clsx(
            type !== "measure-length" ? classes.default : classes.active,
            classes.faIcon
          )}
        />
      </Button>
    </Fragment>
  );
};

export default Measure;
